"use client"

import { motion, AnimatePresence } from "framer-motion"
import React, { type JSX } from "react"

type HoverImageProps = {
  defaultImage: JSX.Element
  hoverImage: JSX.Element
}

const HoverImage: React.FC<HoverImageProps> = ({
  defaultImage,
  hoverImage,
}) => (
  <AnimatePresence initial={false}>
    <motion.div className="relative group">
      {defaultImage}
      {hoverImage}
    </motion.div>
  </AnimatePresence>
)

export default HoverImage
